// รายชื่อบัญชีสำหรับ auto-login ตาม subdomain ของเว็บไซต์
//
// วิธีเพิ่ม subdomain ใหม่: เพิ่ม key ใหม่ในอ็อบเจกต์นี้ที่เดียว ไม่ต้องแก้โค้ด logic อื่นเลย
// key   = ชื่อ subdomain (ส่วนแรกของ hostname ก่อนจุดแรก)
//         เช่น https://bangyaisao.envionyx.sgroupinnovation.com -> key คือ "bangyaisao"
// value = { username, password } ที่จะใช้ auto-login ให้อัตโนมัติเมื่อเข้าเว็บผ่าน subdomain นี้
export default {
  bangyaisao: {
    username: 'bangyaisaouser',
    password: 'bangyaisaouser1234',
  },
  bangplub: {
    username: 'bangplub',
    password: '12345678@user',
  },
  banglane: {
    username: 'banglane',
    password: 'banglane@user',
  },
  // ตัวอย่างการเพิ่ม subdomain อื่นในอนาคต:
  // othersite: {
  //   username: 'othersiteuser',
  //   password: 'othersitepassword',
  // },
};
